import React from 'react';
import { Trans } from '@lingui/react';
import styled from 'styled-components';

const VideoNotFound = styled.div`
  width: 100%;
  padding-top: 56.25%;
  background-color: black;
  color: white;
  position: relative;

  & > * {
    font-size: 13px;
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    text-align: center;
    transform: translateY(-50%);
  }
`;

const CustomMessage = styled.div`
  > :first-child {
    margin-top: 0;
  }
`;

export const PlayerNotFound = ({ message = null }) => {
  return (
    <VideoNotFound>
      {message ? (
        <CustomMessage
          dangerouslySetInnerHTML={{ __html: message }}
        ></CustomMessage>
      ) : (
        <code>
          <Trans id="video.video_not_found" message={'Video not found'} />
        </code>
      )}
    </VideoNotFound>
  );
};
